// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/icon/style/index.less
// module id = 1789
// module chunks = 1